:host {
    .ti-create-myti-list-label-count {
        margin-top: $polaris-space-2;
    }

    .ti-create-myti-list-row {
        margin-bottom: $polaris-space-4;
    }

    .ti-create-myti-list-form-row {
        margin-bottom: $polaris-space-2;
    }

    .ti-create-myti-list-listname-btn {
        margin-left: $polaris-space-2;
    }

    .ti-create-myti-list-add-tag-btn {
        margin-left: $polaris-space-4;
        margin-top: -3px;
    }

    .ti-create-myti-list-tags {
        margin-bottom: $polaris-space-2;

        ti-chip {
            margin-right: $polaris-space-2;
            margin-bottom: $polaris-space-2;
        }
    }
    // Progress transition
    .ti-create-myti-dialog-loader-container {
        position: absolute;
        align-items: center;
        justify-content: center;
        opacity: 1;
        display: flex;
        width: 100%;
        height: calc(100% - 65px); // To offset title
        left: 0;
        bottom: 0;
        pointer-events: none;

        ti-progress {
            transform: translate(0, -16px); // vertically center - half of loader width
        }
    }

    .ti-create-myti-list-listname-invalid-error {
        color: $pl-error-color;
        line-height: $polaris-line-height-2;
        margin-top: $polaris-space-4;
    }

    @include mix-for-sizes-down(phone) {

        ti-button,
        .ti-create-myti-list-listname-btn,
        .ti-create-myti-list-form-row {
            margin: 0;
        }

        ti-button,
        ti-input {
            width: 100%;
            margin-bottom: $polaris-space-4;
        }

        .ti-create-myti-list-listname-btn {
            margin-bottom: 0;
        }

        .ti-create-myti-list-label-count {
            margin-top: 0;
        }

        .ti-create-myti-list-add-tag-btn{
            margin-left:0;
        }
    }
}
